// extracted by mini-css-extract-plugin
export var btn = "C_mB q_rF q_rg d_bz d_bP d_bD d_dw";
export var full = "C_vb d_w d_H";
export var hoverStyle = "C_mF";
export var zoom = "C_mG";